import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
  import Chart, {
    ChartConfiguration,
    ChartData,
    BarControllerChartOptions,
  } from "chart.js/auto";

  interface Dataset {
    type: string;
    label: string;
    data: number[];
    backgroundColor: string;
  }

  interface MixedChartProps {
    data: {
      labels: string[];
      datasets: Dataset[];
    };
    options: BarControllerChartOptions;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MixedChart',
  props: {
    data: {},
    options: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;
  const chartCanvas = ref<HTMLCanvasElement | null>(null);
  const chartError = ref(false);

  const initializeChart = () => {
    const ctx = chartCanvas.value;

    if (!ctx) {
      return (chartError.value = true);
    }

    const dataToChart: ChartData<"bar" | "scatter", number[], string> = {
      labels: props.data.labels || [],
      datasets: props.data.datasets.map((dataForChart) => {
        return {
          type: "bar",
          label: dataForChart.label,
          data: dataForChart.data,
          backgroundColor: dataForChart.backgroundColor,
        };
      }),
    };

    const chartConfig: ChartConfiguration<"bar" | "scatter", number[], string> =
      {
        type: "scatter",
        data: dataToChart,
        options: {
          ...props.options,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      };

    return new Chart(ctx, chartConfig);
  };

  onMounted(() => {
    initializeChart();
  });

const __returned__ = { props, chartCanvas, chartError, initializeChart, onMounted, ref, get Chart() { return Chart }, get ChartConfiguration() { return ChartConfiguration }, get ChartData() { return ChartData }, get BarControllerChartOptions() { return BarControllerChartOptions } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})